"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersInfoSchema = exports.UserInfoSchema = void 0;
const EUserRole_1 = require("./EUserRole");
const zod_1 = require("zod");
const UserInfoSchema = zod_1.z.object({
    Email: zod_1.z.string(),
    Name: zod_1.z.string(),
    UserId: zod_1.z.string(),
    Structure: zod_1.z.string().optional(),
    Role: zod_1.z.nativeEnum(EUserRole_1.EUserRole),
});
exports.UserInfoSchema = UserInfoSchema;
const UsersInfoSchema = zod_1.z.array(UserInfoSchema);
exports.UsersInfoSchema = UsersInfoSchema;
